import { filter, OperatorFunction } from 'rxjs';

export function filterEmptyArray<T>(): OperatorFunction<T, NonNullable<T>> {
  return filter((value: T): value is NonNullable<T> => value !== null && value !== undefined && Array.isArray(value) && value.length > 0);
}
